import React, { useState, useCallback, useMemo, useContext } from 'react';
import useLeaveContracts from '@ubeya/shared/hooks/account/useLeaveContracts';
import { SORT_BY_STRING } from '@ubeya/shared/utils/sorting';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import ConfigContext from '../../../contexts/ConfigContext';

const LeaveContractsFilter = ({ defaultValue, handleClose, onApply, search, onChange, hideLayout = false }) => {
  const { t } = useContext(ConfigContext);
  const { leaveContracts = [] } = useLeaveContracts();
  const [values, setValues] = useState(defaultValue || []);

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  const filteredOptions = useMemo(() => {
    const noContractOption = { value: 0, label: t('noLeaveContractAssigned') };
    const contractOptions = (leaveContracts || []).map((contract) => ({
      value: contract.id,
      label: contract.isDeleted ? `${contract.name} (${t('deleted')})` : contract.name
    }));
    const sorted = [noContractOption, ...contractOptions.sort(SORT_BY_STRING('label'))];
    return search ? sorted.filter(({ label }) => label && label.toLowerCase().includes(search.toLowerCase())) : sorted;
  }, [leaveContracts, search, t]);

  if (!filteredOptions.length) {
    return null;
  }

  return (
    <FilterLayout
      name={t('employeeLeaveContract')}
      handleClose={handleClose}
      onApply={() => onApply(values)}
      hideLayout={hideLayout}>
      {filteredOptions.map(({ value, label }) => (
        <DropDown.Item key={value}>
          <CheckBox
            name={`leave-contract-${value}`}
            value={values.includes(value)}
            label={label}
            onChange={() => handleChange(value)}
          />
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default LeaveContractsFilter;
